/** 主题类型 */
export enum Theme {
    AUI = 'aui',
    SIMPLE_MODE = 'simple-mode'
}
